// extracted by mini-css-extract-plugin
export default {"logo":"Eaa","cancel":"Faa","stickyheader":"Gaa","buttonswrap":"Haa","item":"Iaa","starterKit":"Jaa","boldHeader":"Kaa","reviewheader":"Laa","text":"Maa","username":"Naa"};
    if(module.hot) {
      // 1730991513009
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  